import {Navigate, useLocation} from "react-router-dom";
import {RoutePaths} from "../../../../util/constants";
import {ReactElement} from "react";

type Props = {
    showRoute: boolean;
    redirectTo?: RoutePaths;
    children: ReactElement;
};

export default function ProtectedRoute({
                                           showRoute,
                                           redirectTo = RoutePaths.HOME,
                                           children,
                                       }: Props) {
    const location = useLocation();

    // Extract ?redirect=... if present
    const params = new URLSearchParams(location.search);
    const redirectParam = params.get("redirect");

    const finalRedirect = redirectParam || redirectTo;

    return showRoute ? children : <Navigate to={finalRedirect} replace/>;
}
